/*
 * @Date: 2023-10-31 16:29:33
 * @Author: pengling pengling@piesat.cn
 * @Description: 国标平台视频接口
 */
import axios from 'axios';
import { cameraPrefix, } from '@/configs/index';

export default class CameraApi {
  static readonly prefix = cameraPrefix;

  static user = {
    name: 'admin',
    pwd: '21232f297a57a5a743894a0e4a801fc3',
  };

  static token = '';

  // 获取token
  static getToken = (): Promise<any> => {
    const params = {
      username: CameraApi.user.name,
      password: CameraApi.user.pwd,
    };

    return axios.get(`${CameraApi.prefix}/user/login`, { params, }).then(({ data, }) => {
      const token = data?.data?.accessToken || '';

      CameraApi.token = token;

      return token;
    });
  };

  // 获取设备列表
  static getDevList = (params: any): Promise<any> => axios
    .get(`${CameraApi.prefix}/device/query/devices`, {
      headers: {
        'Access-Token': CameraApi.token,
      },
      params,
    })
    .then(({ data, }) => data.data);

  // 获取设备通道列表
  static getChannelList = (devId: string, params: any): Promise<any> => axios
    .get(`${CameraApi.prefix}/device/query/devices/${devId}/channels`, {
      headers: {
        'Access-Token': CameraApi.token,
      },
      params,
    })
    .then(({ data, }) => data.data);

  // 获取公司名下所有通道列表
  static getAllChannelList = (params: any): Promise<any> => axios
    .post(`${CameraApi.prefix}/device/query/devices/byChannels`,
      {},
      {
        headers: {
          'Access-Token': CameraApi.token,
        },
        params,
      })
    .then(({ data, }) => data?.data);

  // 获取url
  static getUrl = (devId: string, channelId: string, params: any): Promise<string> => axios
    .get(`${CameraApi.prefix}/play/start/${devId}/${channelId}`, {
      headers: {
        'Access-Token': CameraApi.token,
      },
      params,
    })
    .then(({ data, }) => data.data);

  // 云台控制
  static ptControl = (devId: string, channelId: string, params: any): Promise<any> => axios.post(
    `${CameraApi.prefix}/ptz/control/${devId}/${channelId}`,
    {},
    {
      headers: {
        'access-token': CameraApi.token,
      },
      params,
    }
  );
}
